<template>
  <div id="app">
    <ttxl-header></ttxl-header>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>

    <!-- 乐语客服 -->
    <div class="fixed-bar" @click="showService">
      <div class="on-line"></div>
    </div>
    <ttxl-footer></ttxl-footer>
  </div>
</template>

<script>
import TtxlHeader from '@/components/header/'
import TtxlFooter from '@/components/footer/'
import { tokens, spaStateSync } from '@/util/api/modules/auth.js'
import Storage from 'store'
import ExpirePlugin from 'store/plugins/expire'
import { SKEY_TOKEN, SKEY_USERINFO } from '@/config/storage.config.js'
import { mapMutations } from 'vuex'
Storage.addPlugin(ExpirePlugin)

export default {
  name: 'app',
  metaInfo: {
    title: '',
    titleTemplate: (titleChunk) => {
      return titleChunk ? `${titleChunk} - 天天心理网 - 专业的心理学在线学习平台` : '天天心理网 - 专业的心理学在线学习平台'
    }
  },
  components: {
    TtxlHeader,
    TtxlFooter
  },
  created () {
    let token = Storage.get(SKEY_TOKEN)
    if (token) {
      this.set_token(token)
      let userinfo = Storage.get(SKEY_USERINFO)
      if (userinfo && userinfo.id) {
        this.set_userinfo({userinfo: userinfo})
      }
      tokens().then(response => { // 更新
        let {token, user} = response
        this.set_token(token)
        this.set_userinfo({userinfo: user})
      }).catch(response => {
        if (response.status === 401) { // 同步推出
          spaStateSync({method: 'logout'}).then(response => {
            Storage.remove(SKEY_TOKEN)
            Storage.remove(SKEY_USERINFO)
          }).catch(() => {
            // todo
          })
        }
      })
      // 同步登陆
      this.syncLogin()
    } else {
      Storage.remove(SKEY_TOKEN)
      Storage.remove(SKEY_USERINFO)
      // 尝试同步登陆
      this.syncLogin()
    }
  },
  methods: {
    ...mapMutations(['set_token', 'set_userinfo']),
    syncLogin () {
      spaStateSync({method: 'login'}).then(response => {
        const { status, data } = response.data
        if (status) {
          const expireDate = (new Date()).getTime() + 86400 * 29 * 1000
          Storage.set(SKEY_TOKEN, data.token, expireDate)
          Storage.set(SKEY_USERINFO, data.user, expireDate)
          this.set_token(data.token)
          this.set_userinfo({userinfo: data.user, renew: 'Y'})
        }
      }).catch(() => {
        // todo
      })
    },
    // 唤起客服
    showService () {
      doyoo.util.openChat('g=10087540')
    }
  }
}
</script>

<style lang="stylus">
#app {
  font-family: 'PingFang SC', 'Microsoft Yahei', Helvetica Neue,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fade-enter-active
.fade-leave-active
    transition opacity .5s
.fade-enter
.fade-leave-active
    opacity  0
.clearfix
  &:before
  &:after
    display table
    content " "
  &:after
    clear both
.pull-right
  float right !important
.pull-left
  float left !important

// 乐语客服
.fixed-bar
  position fixed
  bottom: 100px
  right: 0
  z-index 1000 !important
  .on-line
    width: 70px
    height: 70px
    border-radius: 50%
    background url('~@/assets/common/onLine.png') no-repeat
    background-size: contain

// 隐藏乐语探头调起来的弹出
div#doyoo_f_chat, div#doyoo_f_head, div#doyoo_f_main
  display: none !important
</style>



// WEBPACK FOOTER //
// src/App.vue